function loadView(view) {
  return () =>
    import(/* webpackChunkName: "product" */ `@/views/product/${view}`);
}
export default [
  {
    path: "/list",
    name: "List",
    component: loadView("list.vue"),
    meta: {
      title: "PA百宝箱"
    }
  },
  {
    path: "/detail",
    name: "Detail",
    component: loadView("detail.vue"),
    meta: {
      title: "PA百宝箱"
    }
  },
  {
    path: "/compare-detail",
    name: "CompareDetail",
    component: loadView("compareDetail.vue"),
    meta: {
      title: "PA百宝箱"
    }
  }
];
